import home from "./HomePage.reducer"
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    home
});
export default rootReducer;
